import React from "react";

function OurTeam() {
  return (
    <>

    <div id="inner-hero" className="inner-hero bg-com pt-50 pb-50">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="inner-text text-center">
                        <div className="inner-title">Our <span>Team</span></div>
                        <ul className="inner-link">
                            <li>Home</li>
                            <li>Our Team</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>


   <section className="testimonial-inner pt-50 pb-50">
  <div className="container">

    <div className="row">

      {/* Global Chairman */}
      <div className="col-lg-12 col-md-12">
        <div className="testimonial-inner-item">

          <p>
            Ankur Aggarwal, founder of BNW, brings extensive experience and a strong
            professional background to the company’s leadership. A Chartered Accountant by
            qualification, he spent over a decade in finance before moving into the real estate
            sector in 2021. Guided by a focus on integrity and professionalism, Ankur founded
            BNW to provide comprehensive real estate consulting and development services.
            Under his direction, BNW has grown into a respected organization supported by a
            skilled team of consultants, chartered accountants, and legal advisors. In just three
            years, the company’s Assets Under Development (AUD) have reached 22 billion
            AED. As BNW’s consulting operations expanded, Ankur recognized the need to
            explore new areas of growth. In 2023, he founded BNW Buying and Selling LLC to
            acquire land and plots across the UAE. Continuing this expansion, he launched BNW
            Developments in 2024 to initiate premium mixed-use projects in Ras Al Khaimah and
            Dubai, further establishing BNW as a growing name in the region’s real estate
            landscape.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-7.jpg"
              alt="Mr. Ankur Aggarwal"
            />

            <h3 style={{ color: "#fff" }}>Global Chairman "121 BBTC"</h3>
            <h4>Mr. Ankur Aggarwal</h4>
            <span>Chairman & Founder</span>
          </div>

        </div>
      </div>


      {/* India Chairman */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Rahul Sharma, the Promoter and Convener of BNW Group, is a seasoned
            professional with rich experience in the international real estate market.
            His strategic vision and global perspective have been instrumental in driving
            BNW's growth and strengthening its presence across diverse markets.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-1.jpg"
              alt="Mr. Rahul Sharma"
            />

            <h3 style={{ color: "#fff" }}>India Chairman "121 BBTC"</h3>
            <h4>Mr. Rahul Sharma</h4>
            <span>Convener & Promoter BNW</span>
          </div>

        </div>
      </div>


      {/* Delhi Chief Patron */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Mr. Sunil Goel, Managing Director of Numax Realcon Pvt. Ltd., is a visionary
            leader with over 34 years of experience in the real estate industry. Renowned
            for his strategic foresight and commitment to excellence, he has played a
            pivotal role in shaping landmark developments and driving sustainable growth
            within the sector.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-2.jpg"
              alt="Mr. Sunil Kumar Goel"
            />

            <h3 style={{ color: "#fff" }}>
              Delhi Chief Patron "121 BBTC"
            </h3>

            <h4>Mr. Sunil Kumar Goel</h4>
            <span>Managing Director</span>
          </div>

        </div>
      </div>


      {/* S.K. Goyal */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Mr. S.K. Goyal, Co-Founder and Managing Director of SPAR Group, is a
            seasoned professional with deep expertise in real estate development and
            infrastructure. With a commitment to innovation and excellence, he has been
            instrumental in driving SPAR Group’s growth, building a strong legacy of
            trust, quality, and sustainable development.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-3.jpg"
              alt="Mr. S.K. Goyal"
            />

            <h3 style={{ color: "#fff" }}>Delhi Chief Patron "121 BBTC"</h3>
            <h4>Mr. S.K. Goyal</h4>
            <span>Managing Director</span>
          </div>

        </div>
      </div>


      {/* Subhash Chander Gupta */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Established in 1989 by visionary founder and Chairman Mr. Subhash Chander
            Gupta, Lancer Footwear stands today as a symbol of innovation and
            craftsmanship in the Indian footwear industry. With Mr. Saurabh Gupta the
            brand continues to set new benchmarks in design, comfort, and global reach.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-4.jpg"
              alt="Mr. Subhash Chander Gupta"
            />

            <h3 style={{ color: "#fff" }}>Delhi Patron "121 BBTC"</h3>
            <h4>Mr. Subhash Chander Gupta</h4>
            <span>Chairman Lancer Footwear</span>
          </div>

        </div>
      </div>


      {/* Ashok Gupta */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Founded in 2003, Sakarni is a leading name in construction and
            beautification products, recognized as the No. 1 Plaster of Paris brand
            in Northern India. Driven by innovation, quality, and customer trust,
            the company continues to expand through global collaborations and a
            strong commitment to excellence.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-5.jpg"
              alt="Mr. Ashok Gupta"
            />

            <h3 style={{ color: "#fff" }}>Delhi Patron "121 BBTC"</h3>
            <h4>Mr. Ashok Gupta</h4>
            <span>Chairman Sakarni</span>
          </div>

        </div>
      </div>


      {/* V.P. Tandon */}
      <div className="col-lg-4 col-md-6">
        <div className="testimonial-inner-item">

          <p>
            Sh. V.P. Tandon, Chairman of Kamal & Vandana Group of Institutions,
            is a distinguished educationist and visionary leader dedicated to
            advancing quality education. Recognized for his outstanding
            contributions to the field, he was honoured with the prestigious
            Hind Rattan Award by Hon’ble Ambassador Phillippe Le Gall,
            High Commissioner of Seychelles to India.
          </p>

          <div className="testimonial-details">
            <img
              src="/assets/img/test-6.jpg"
              alt="Mr. V.P. Tandon"
            />

            <h3 style={{ color: "#fff" }}>
              Delhi Patron "121 BBTC"
            </h3>

            <h4>Mr. V.P. Tandon</h4>
            <span>Chairman & Vandana Group</span>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>
  
    </>
  );
}

export default OurTeam;